import { OmniIconComponent } from "../../../../../shared";
import { useMemo, useState, useRef, useEffect } from "react";

export default function MediaOrderDetailsModal({
    isOpen,
    onClose,
    syncIcon,
    integrationStatus,
    campaignName,
    dateRange,
    prismaId,
    clientCode,
    productCode,
    lastModified,
    lastModifiedBy,
    channels,
    onEditChannels
}) {

    const displayChannels = (channelNames) => {
        // Handle both array and string formats
        const visibleChannels = Array.isArray(channelNames)
            ? channelNames.filter(Boolean)
            : (channelNames || '').split(',').map(name => name.trim()).filter(Boolean);

        if (visibleChannels.length === 0) {
            return '-';
        }

        return (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', }} >
                {visibleChannels.map((channel, index) => (
                    <span key={index} className="ad-serving-fee-pill-container">
                        <span className="ad-serving-fee-pill">
                            {channel}
                        </span>
                    </span>
                ))}
            </div>
        );
    };

    const infoRows = useMemo(() => [
        {
            label: 'Integration Status:',
            value: integrationStatus || '',
            iconId: syncIcon,
            showIcon: true
        },
        {
            label: 'Campaign Name:',
            value: campaignName || '-'
        },
        {
            label: 'Start / End Date:',
            value: dateRange || '-'
        },
        {
            label: 'Prisma ID:',
            value: prismaId || '-'
        },
        {
            label: 'Client Code:',
            value: clientCode || '-'
        },
        {
            label: 'Product Code:',
            value: productCode || '-'
        },
        {
            label: 'Last Modified:',
            value: lastModified || '-',
            avatarText: lastModifiedBy || ''
        },
        {
            label: 'Channels:',
            value: displayChannels(channels),
            isEditable: true,
        }
    ], [integrationStatus, campaignName, dateRange, prismaId, clientCode, productCode, lastModified, lastModifiedBy, channels]);

    if (!isOpen) return null;

    return (
        <div className="media-order-details-modal modal is-active">
            <div className="modal-body card-content modal-content">
                <div className="modal-header">
                    Media Order Details
                    <button className="tertiary" onClick={onClose}>
                        <OmniIconComponent icon-id="omni:interactive:close" className="close-icon" />
                    </button>
                </div>
                <hr />
                <div className="modal-info-rows">
                    {infoRows.map((row, index) => (
                        <div key={index} className="info-row">
                            <div className="info-label">{row.label}</div>
                            <div className="info-value-wrapper">
                                {row.showIcon && row.iconId && (
                                    <OmniIconComponent
                                        icon-id={row.iconId}
                                        className="status-icon"
                                    />
                                )}
                                {row?.avatarText && (
                                    <div className="avatar-circle">
                                        {row.avatarText}
                                    </div>
                                )}
                                <div className="info-value">
                                    {row.value}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
